const Yup = require('yup');

const updateAccountDataForEntitySchema = Yup.object()
  .shape({
    rowsToUpdate: Yup.array()
      .of(
        Yup.object().shape({
          jurisdictionId: Yup.string().required(),
          accountAmount: Yup.mixed()
            .required()
            .transform((value, originalValue) => {
              if (originalValue === null || typeof originalValue === 'undefined') {
                return originalValue;
              }
              return String(originalValue);
            }),
        }),
      )
      .notOneOf([undefined, null]), // eslint-disable-line no-undefined
  })
  .strict();

module.exports = {
  updateAccountDataForEntitySchema,
};
